module.exports = __webpack_public_path__ + "static/media/support.b4cb6507.svg";